import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import AuthenticateRoute from 'src/components/organisms/app-layouts/authenticate-route/authenticate-route';
import { WorkflowDetailPage } from 'src/modules/tools/components/pages/workflow-detail.page';
import { globalSearchSchema } from 'src/modules/shared/schemas/search.schema';

const pathParamsSchema = z.object({
  workflowId: z.string(),
});

export const Route = createFileRoute('/tools/workflows/$workflowId/')({
  component: WorkflowDetailComponent,
  validateSearch: (search) =>
    globalSearchSchema
      .merge(
        z.object({
          phoneVersion: globalSearchSchema.shape.phoneVersion.default(
            'v1' as const
          ),
        })
      )
      .parse(search),
  params: {
    parse: (params) => pathParamsSchema.parse(params),
  },
});

function WorkflowDetailComponent() {
  const { workflowId } = Route.useParams();
  return (
    <AuthenticateRoute>
      <WorkflowDetailPage workflowId={workflowId} />
    </AuthenticateRoute>
  );
}

export default Route;
